import { Injectable } from '@angular/core';
import { Globals } from '../../globals';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})

export class SubjectService {
    constructor(private global: Globals, private _httpClient: HttpClient) { }

  

    GetSubjectList() {
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this._httpClient.get(this.global.G_apiUrl +'/subject/CounterByUser/'+
        this.global.loggedUser.user.user_reg_id,{headers:headers});
    }

    GetIndividualSubjectList(subjectId:any)
    {
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this._httpClient.get(this.global.G_apiUrl +'/approvedEmail/approvedBySubject/'+
        this.global.loggedUser.user.user_reg_id+'/'+subjectId,{headers:headers});
    }
}